<template>
    <div v-if="dataStore.termsVisable" id="terms-popup">
        <div>
            <span class="close-popup" @click="showTermsOnMe()"><i class="fas fa-times"></i></span>
            <div class="container">
                <div class="row">
                    <div v-if="project.terms !== ''" class="col-12" v-html="project.terms"></div>
                    <div v-else class="col-12">
                        <h3>Allmänna regler</h3>
                        <p>Eventuella personuppgifter om lämnats i denna enkät kommer att behandlas i enlighet med dataskyddsförordningen och endast för de ändamål som enkäten avser.</p><p>Uppgifterna som lämnas används för att handlägga ärendet.</p>
                        <p>Det du publicerar i form av vision eller kommentar [eller bilder] får inte:</p>
                        <ul>
                            <li>kränka andra personer eller utpeka dem som brottsliga</li>
                            <li>vara hotfullt, obscent eller av stötande karaktär</li>
                            <li>strida mot upphovsrätt eller annan immateriell rätt. Detta innebär bl a förbud mot publicering av copyrightskyddat material.</li>
                            <li>innehålla hets mot folkgrupp eller på annat sätt ha ett rasistiskt eller sexistiskt innehåll</li>
                            <li>innehålla hets mot någon pga sexuell läggning</li>
                            <li>innehålla våldsskildring eller barnpornografi</li>
                            <li>innehålla länk till andra webbsidor vars innehåll i sin tur strider mot dessa instruktioner och villkor</li>
                            <li>innehålla uppmaning till brott eller utgöra del av brottslig verksamhet</li>
                            <li>innefatta spridning av datavirus</li>
                            <li>i övrigt vara av sådan karaktär att det inte lämpar sig för publicering</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import dataStore from "../../store";
import { showTerms } from './../../functions'

export default {

    data() {
        return {
            dataStore: dataStore,

        };
    },

    props: {
        project: Object
    },

    methods : {

        showTermsOnMe: function() {
            showTerms()
        }

    }

};

</script>

